import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

const LIMIT_API_PAGE = 200

Vue.use(Vuex);
let size = location.hostname === "localhost" ? '' : '';
let apiUrl = `${size}/restApi/news/`;

export default new Vuex.Store({
  state: {
    translations: [],
    posts: [],
    banner: {},
    currentPage: 1,
    nextPage: true,
    activeUrl: "",
    title: {},
    description: {},
    header: {},
    headerFocus: 'none'
  },
  getters: {
    getTranslation: (state) => (key) => {
      return key in state.translations ? state.translations[key] : undefined;
    },
    getPosts: state => {
      return state.posts;
    },
    getPost: (state) => (code) => {
     return state.posts.find(post => post.code == code);
    },
    getBanner: state => {
      return state.banner;
    },
    filterPostsByCategory: (state) => (category) => {
      return state.posts.filter(post => post.category_id == category);
    },
    getPreviousPost: (state) => (id) => {
      let currentPost = state.posts.find(post => post.id == id);
      let index = state.posts.indexOf(currentPost);
      let previousPostIndex = index - 1;
      if(previousPostIndex < 0) previousPostIndex = state.posts.length - 1;
      return state.posts[previousPostIndex];
    },
    getNextPost: (state) => (id) => {
      let currentPost = state.posts.find(post => post.id == id);
      let index = state.posts.indexOf(currentPost);
      let nextPostIndex = index + 1;
      if(nextPostIndex >= state.posts.length) return false;
      return state.posts[nextPostIndex];
    },
    getMostPopularPosts: state => {
        return state.posts.slice().sort( (a, b) => {
         return b.views - a.views;
        });
    },
    isNextPage: state => {
      return state.nextPage;
    },
    getCurrentPage: state => {
      return state.currentPage;
    },
    getCurrentUrl: state => {
      return state.activeUrl;
    },
    getTitle: state => {
      return state.title;
    },
    getDescription: state => {
      return state.description;
    },
    getHeader: state => {
      return state.header;
    },
    getHeaderFocus: state => {
      return state.headerFocus;
    }
  },
  mutations: {
    UpdateTranslations(state, payload) {
      state.translations = payload;
    },
    AddPostToArray(state, payload) {
      let post = state.posts.findIndex(post => post.id == payload.id);
      if(post > -1) {
        state.posts[post] = payload;
      } else {
        state.posts.push(payload);
      }
    },
    updatePostsArray(state, payload) {
      state.posts.push(...payload);
    },
    updateBannerInfo(state, payload) {
      state.banner = payload;
    },
    updateCurrentPageCount(state) {
      state.currentPage++;
    },
    updateNextPage(state, value) {
      state.nextPage = value;
    },
    updateTitle(state, value) {
      state.title = value;
    },
    updateDescription(state, value) {
      state.description = value;
    },
    updateHeader(state, value) {
      state.header = value;
    },
    updateHeaderFocus(state, value) {
      state.headerFocus = value;
    },
    changeCurrentUrl(state, payload) {
      state.activeUrl = payload;
    }
  },
  actions: {
    async GET_TRANSLATIONS({commit}) {
      try {
        const response = await axios.get(`${size}/news/ajax/langs.php`);
        commit('UpdateTranslations', response.data);
      } catch(error) {
        // console.log(error)
      }
    },
    async GET_POSTS({commit, getters}) {
      try {
        let response = await axios.get(apiUrl, {
          params: {
            "PAGE": getters.getCurrentPage
          }
        });

        commit('updatePostsArray', response.data.ITEMS);
        commit('updateBannerInfo', response.data.BANNER);
        commit('updateTitle', response.data.TITLE);
        commit('updateDescription', response.data.DESCRIPTION);
        commit('updateHeader', response.data.HEADER);
        commit('updateCurrentPageCount');
        commit('updateNextPage', LIMIT_API_PAGE <= response.data?.ITEMS?.length);
      } catch(error) {
        // console.log(error);
      }
    },
    async GET_POST({commit}, code) {
      try {
        const response = await axios.get(apiUrl, {
          params: {
            "CODE": code
          }
        });
        if(response.data.ITEMS.length) {
          commit('AddPostToArray', response.data.ITEMS[0]);
          commit('changeCurrentUrl', response.data[0]?.category);
        }
      } catch(error) {
        // console.log(error)
      }
    }
  },
  modules: {
  }
})
